/**
 * State of members
 */

/**
 * @returns Whether the company members are currently fetched with the request, which a request
 * stops being once the members are invalidated or reset, or once it completed
 */
export function isCurrentCompanyMembersRequest(state, requestId) {
  return state.fetching.companyMembersRequestId === requestId;
}